import * as React from 'react'
import { sizes } from './const'

export interface QuestionIconProps {
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     */
    size?: 'small' | 'medium' | 'large'
}

export const QuestionIcon = ({
    className = 'js_QuestionIcon',
    size = 'small',
}: QuestionIconProps) => {
    return (
        <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`${className} ${sizes[size]}`}
        >
            <path
                d="M7.5 13.125C10.6066 13.125 13.125 10.6066 13.125 7.5C13.125 4.3934 10.6066 1.875 7.5 1.875C4.3934 1.875 1.875 4.3934 1.875 7.5C1.875 10.6066 4.3934 13.125 7.5 13.125Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.5 11.0156C7.75888 11.0156 7.96875 10.8058 7.96875 10.5469C7.96875 10.288 7.75888 10.0781 7.5 10.0781C7.24112 10.0781 7.03125 10.288 7.03125 10.5469C7.03125 10.8058 7.24112 11.0156 7.5 11.0156Z"
                fill="black"
            />
            <path
                d="M7.5 8.4375V7.96875C7.82449 7.96875 8.14168 7.87253 8.41148 7.69226C8.68128 7.51198 8.89156 7.25575 9.01574 6.95597C9.13991 6.65618 9.17241 6.32631 9.1091 6.00806C9.0458 5.68981 8.88954 5.39747 8.6601 5.16803C8.43065 4.93858 8.13832 4.78233 7.82007 4.71902C7.50182 4.65572 7.17195 4.68821 6.87216 4.81239C6.57238 4.93656 6.31614 5.14684 6.13587 5.41664C5.9556 5.68644 5.85938 6.00364 5.85938 6.32813"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
